import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReports = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.24717 32.1111C4.32372 32.1111 3.53459 31.7837 2.8781 31.1255C2.56025 30.8184 2.30856 30.4495 2.1385 30.0415C1.96844 29.6335 1.88359 29.1951 1.88917 28.7531V5.24711C1.88917 4.32366 2.21658 3.53454 2.8781 2.87637C3.18493 2.5596 3.5531 2.30869 3.96013 2.13895C4.36716 1.96921 4.80451 1.8842 5.24549 1.88912H28.7531C29.6766 1.88912 30.4657 2.21652 31.1256 2.87637C31.7854 3.53286 32.1111 4.32534 32.1111 5.24711V28.7531C32.1111 29.6765 31.7854 30.4673 31.1272 31.1255C30.8201 31.4432 30.4511 31.6945 30.0431 31.864C29.6351 32.0335 29.1966 32.1176 28.7548 32.1111H5.24717ZM5.24717 28.7531H15.3212V5.24711H5.24717V28.7531ZM18.6792 28.7531H28.7548V17.0001H18.6808V28.7531H18.6792ZM18.6792 13.6421H28.7548V5.24711H18.6808V13.6421H18.6792Z",
		fill: "currentColor"
	})
});
export default SvgReports;
